/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Function to update cart count display
function updateCartCountDisplay() {
  fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then(function(response) {
    return response.json();
  })
  .then(function(cart) {
    // Update cart count displays
    var cartCountElements = document.querySelectorAll('.Header__CartCount');
    cartCountElements.forEach(function(element) {
      element.textContent = cart.item_count;
    });
    
    // Update cart count wrappers visibility with !important priority
    var cartCountWrappers = document.querySelectorAll('.cart-count-wrapper');
    cartCountWrappers.forEach(function(wrapper) {
      if (cart.item_count === 0) {
        wrapper.style.setProperty('display', 'none', 'important');
      } else {
        wrapper.style.setProperty('display', 'inline', 'important');
      }
    });
    
    // Update cart dots
    var cartDots = document.querySelectorAll('.Header__CartDot');
    cartDots.forEach(function(dot) {
      if (cart.item_count === 0) {
        dot.classList.remove('is-visible');
      } else {
        dot.classList.add('is-visible');
      }
    });
    
    // Force recheck after a short delay to ensure changes persist
    setTimeout(function() {
      var wrappers = document.querySelectorAll('.cart-count-wrapper');
      wrappers.forEach(function(wrapper) {
        var countElement = wrapper.querySelector('.Header__CartCount');
        if (countElement && (countElement.textContent === '0' || countElement.textContent.trim() === '')) {
          wrapper.style.setProperty('display', 'none', 'important');
        }
      });
    }, 100);
  })
  .catch(function(error) {
    console.log('Error updating cart count:', error);
  });
}

// Update cart count immediately when products are added
document.addEventListener('product:added', function(event) {
  updateCartCountDisplay();
});

// Update cart count when cart is refreshed (for removals, updates, etc.)
document.addEventListener('cart:refresh', function(event) {
  updateCartCountDisplay();
});

// Also listen for any quantity update clicks in the cart
document.addEventListener('click', function(event) {
  // Check if it's a cart quantity update button
  if (event.target.closest('[data-action="update-item-quantity"]')) {
    // Add a small delay to allow the AJAX request to complete
    setTimeout(function() {
      updateCartCountDisplay();
    }, 500);
  }
});

// Listen for quantity input changes in cart
document.addEventListener('change', function(event) {
  if (event.target.classList.contains('QuantitySelector__CurrentQuantity')) {
    // Add a small delay to allow the AJAX request to complete
    setTimeout(function() {
      updateCartCountDisplay();
    }, 500);
  }
});

// Watch for changes in the cart drawer content and update count accordingly
document.addEventListener('DOMContentLoaded', function() {
  // Set up a MutationObserver to watch for cart content changes
  var cartObserver = new MutationObserver(function(mutations) {
    var shouldUpdate = false;
    mutations.forEach(function(mutation) {
      // Check if cart-related content has changed
      if (mutation.type === 'childList' && 
          (mutation.target.classList.contains('Cart') || 
           mutation.target.closest('.Cart') ||
           mutation.target.classList.contains('Drawer__Main'))) {
        shouldUpdate = true;
      }
    });
    
    if (shouldUpdate) {
      // Small delay to ensure DOM updates are complete
      setTimeout(function() {
        updateCartCountDisplay();
      }, 100);
    }
  });
  
  // Start observing the cart drawer if it exists
  var cartDrawer = document.querySelector('#sidebar-cart');
  if (cartDrawer) {
    cartObserver.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }
  
  // Also observe the main cart page if it exists
  var cartPage = document.querySelector('[data-section-type="cart"]');
  if (cartPage) {
    cartObserver.observe(cartPage, {
      childList: true,
      subtree: true
    });
  }
  
  // Add a periodic check to ensure cart count stays hidden when zero
  setInterval(function() {
    var cartCountWrappers = document.querySelectorAll('.cart-count-wrapper');
    cartCountWrappers.forEach(function(wrapper) {
      var countElement = wrapper.querySelector('.Header__CartCount');
      if (countElement) {
        var count = parseInt(countElement.textContent) || 0;
        if (count === 0) {
          wrapper.style.setProperty('display', 'none', 'important');
        } else if (count > 0) {
          wrapper.style.setProperty('display', 'inline', 'important');
        }
      }
    });
  }, 1000); // Check every second
});



function LoadLibrary(liburl,callback){
    var jscript = document.createElement("script");
    jscript.type = 'text/javascript';
    jscript.src = liburl;
    //for IE type browsers
    if (jscript.readyState) { 
        jscript.onreadystatechange = function () {
            if (jscript.readyState == "loaded" || jscript.readyState == "complete") {
                jscript.onreadystatechange = null;
                callback();
            }
        };
    } else {
        jscript.onload = function () {
            callback();
        };
    }
    document.getElementsByTagName("head")[0].appendChild(jscript);
}


if (!window.jQuery) {  
    LoadLibrary('https://code.jquery.com/jquery-3.3.1.min.js',
        function(){
            console.log('jQuery loaded');
        }
    );         
}



function defer(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}

defer(function(){
$(document).ready(function(){
	$( ".Product__Slideshow .Product__SlideItem" ).clone(true).appendTo( ".slide-placeholder" );
});


	window.VIG = window.VIG || {};
	VIG.loaded = false;
	VIG.VariantChangeCallback = function(){
		var visible_ids = $('.slide-placeholder img:visible').map(function() {
			return $(this).data('image-id');
		}).get();
		$(".flickity-page-dots button").hide();
      	var visible_index = 0;
		var slidesToAdd = [];

		visible_ids.forEach(function(element) {
		slidesToAdd.push($('.slide-placeholder [data-image-id='+element+']').closest('.Product__SlideItem'));
		});
		
        var $sliders = $('.Product__Slideshow.flickity-enabled');
      
    	  $sliders.each(function() {
            
            var $slider = $(this);
            var $sliderInstance = Flickity.data(this);
            if ($sliderInstance != undefined ) {
              
                $sliderInstance.remove($('.Product__Slideshow .Product__SlideItem'));
                slidesToAdd.forEach(function(element) {
                	$sliderInstance.append(element.clone(true));
                  	visible_index = element.attr('data-image-media-position');
                  	$(".flickity-page-dots button[data-index='"+visible_index+"']").show();
                });
            } 
            else{
            console.log('slider instance undefined');
            }
        });		
		
      $(".flickity-page-dots button[data-index]:visible").first().addClass('is-selected');
        window.scrollTo(0, 0);

    }
});/*FIXED BY VIP:2020-05-01 14:49:08 UTC*/

// Filter collapse funtionality fix
(function ($) {
  // Toggle logic
  function toggleOption($title) {
    const $parent = $title.closest('.boost-pfs-filter-option');
    const $content = $parent.find('.boost-pfs-filter-option-content').first();
    const $heading = $title.find('.boost-pfs-filter-option-title-heading').first();
    const $btn = $heading.length ? $heading : $title;

    const isVisible = $content.length && $content.is(':visible');

    $content.stop(true, true).slideToggle(200);

    if (isVisible) {
      $parent.addClass('boost-pfs-filter-option-collapsed');
      $title.removeClass('test');
      $btn.attr('aria-expanded', 'false');
    } else {
      $parent.removeClass('boost-pfs-filter-option-collapsed');
      $title.addClass('test');
      $btn.attr('aria-expanded', 'true');
    }
  }

  // Sync state properly
  function syncInitialState() {
    $('.boost-pfs-filter-option').each(function () {
      const $p = $(this);
      const $content = $p.find('.boost-pfs-filter-option-content').first();
      const $title = $p.find('.boost-pfs-filter-option-title').first();
      const $btn = $title.find('.boost-pfs-filter-option-title-heading').first();

      const isExpanded = $btn.length && $btn.attr('aria-expanded') === 'true';

      // 🔑 Reset animations & force state
      $content.stop(true, true);

      if (isExpanded) {
        $content.show(); // force visible
        $p.removeClass('boost-pfs-filter-option-collapsed');
        $title.addClass('test');
        if ($btn.length) $btn.attr('aria-expanded', 'true');
      } else {
        $content.hide(); // force hidden
        $p.addClass('boost-pfs-filter-option-collapsed');
        $title.removeClass('test');
        if ($btn.length) $btn.attr('aria-expanded', 'false');
      }
    });
  }

  $(function () {
    syncInitialState();

    // Capture-phase click override
    document.addEventListener(
      'click',
      function (e) {
        let node = e.target;
        while (node && node !== document) {
          if (node.classList && node.classList.contains('boost-pfs-filter-option-title')) break;
          node = node.parentNode;
        }
        if (!node || node === document) return;

        // Allow Boost's own clear buttons
        if (
          e.target.closest('.boost-pfs-filter-clear') ||
          e.target.closest('.boost-pfs-filter-clear-all')
        ) {
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        toggleOption($(node));
      },
      true
    );

    // Keyboard support
    $(document).on('keydown', '.boost-pfs-filter-option-title-heading', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        e.stopImmediatePropagation();
        toggleOption($(this).closest('.boost-pfs-filter-option-title'));
      }
    });

    // Re-sync after Boost render
    $(document).on('boost-pfs-filter-rendered', function () {
      setTimeout(syncInitialState, 30);
    });

    // Fallback mutation observer
    const observer = new MutationObserver(function (mutations) {
      let found = false;
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (
            n.nodeType === 1 &&
            (n.matches('.boost-pfs-filter-option') ||
              (n.querySelector && n.querySelector('.boost-pfs-filter-option')))
          ) {
            found = true;
            break;
          }
        }
        if (found) break;
      }
      if (found) {
        setTimeout(syncInitialState, 50);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})(jQuery);


// Override PhotoSwipe zoom settings to show smaller images in modal
(function() {
  // Wait for PhotoSwipe to load
  function overridePhotoSwipe() {
    if (typeof PhotoSwipe === 'undefined') {
      setTimeout(overridePhotoSwipe, 50);
      return;
    }
    
    var OriginalPhotoSwipe = window.PhotoSwipe;
    
    window.PhotoSwipe = function(pswpElement, uiConstructor, items, options) {
      // Override the options to show smaller images
      if (options && items) {
        // Adjust initial zoom level for all items
        items.forEach(function(item) {
          if (item.initialZoomLevel) {
            item.initialZoomLevel = 1.2; // Change this value: higher = smaller image
          }
        });
        
        // Override the scale mode
        options.scaleMode = 'fit'; // 'fit' shows full image, 'zoom' auto-fills viewport
        
        // Override double-tap/click zoom
        var originalGetDoubleTapZoom = options.getDoubleTapZoom;
        options.getDoubleTapZoom = function(isMouseClick, item) {
          return 1.2; // Change this value for zoom behavior
        };
      }
      
      return new OriginalPhotoSwipe(pswpElement, uiConstructor, items, options);
    };
    
    // Copy prototype and static properties
    window.PhotoSwipe.prototype = OriginalPhotoSwipe.prototype;
    for (var key in OriginalPhotoSwipe) {
      if (OriginalPhotoSwipe.hasOwnProperty(key)) {
        window.PhotoSwipe[key] = OriginalPhotoSwipe[key];
      }
    }
  }
  
  overridePhotoSwipe();
})();

// Add "scrolled" class to mobile-add-to-cart when wrapper-qty-add is out of viewport (mobile only)
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on mobile
  function isMobile() {
    return window.innerWidth <= 700;
  }
  
  if (!isMobile()) {
    return; // Exit if not mobile
  }
  
  var mobileAddToCart = document.querySelector('.mobile-add-to-cart');
  var productGallery = document.querySelector('.Product__Gallery');
  var wrapperQtyAdd = document.querySelector('.wrapper-qty-add');
  
  if (!mobileAddToCart || !productGallery || !wrapperQtyAdd) {
    return; // Exit if elements don't exist
  }
  
  // Function to check if element is out of viewport
  function isOutOfViewport(element) {
    var rect = element.getBoundingClientRect();
    return (
      rect.bottom < 0 || // Element is above viewport
      rect.top > window.innerHeight // Element is below viewport
    );
  }
  
  // Function to handle scroll
  function handleScroll() {
    if (isOutOfViewport(productGallery) && isOutOfViewport(wrapperQtyAdd)) {
      mobileAddToCart.classList.add('scrolled');
    } else {
      mobileAddToCart.classList.remove('scrolled');
    }
  }
  
  // Attach scroll event listener
  window.addEventListener('scroll', handleScroll);
  
  // Check initial state
  handleScroll();
  
  // Also check on resize in case user rotates device
  window.addEventListener('resize', function() {
    if (isMobile()) {
      handleScroll();
    } else {
      mobileAddToCart.classList.remove('scrolled');
    }
  });
});

// Enable product image click to open zoom modal on mobile
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a product page and zoom is enabled
  var productSection = document.querySelector('[data-section-type="product"]');
  var zoomContainer = document.querySelector('.pswp');
  
  if (!productSection || !zoomContainer) {
    return; // Exit if not on product page or zoom not enabled
  }
  
  // Function to check if we're on mobile/tablet (pocket breakpoint)
  function isMobileView() {
    return window.matchMedia('(max-width: 640px)').matches;
  }
  
  // Add click event using event delegation (more efficient and works with dynamic content)
  var productSlideshow = document.querySelector('.Product__Slideshow');
  
  if (productSlideshow) {
    // Use event delegation on the slideshow container
    productSlideshow.addEventListener('click', function(event) {
      // Only trigger on mobile
      if (!isMobileView()) {
        return;
      }
      
      // Check if clicked element is or is within a product slide image
      var slideItem = event.target.closest('.Product__SlideItem--image');
      
      if (slideItem) {
        // Prevent default behavior
        event.preventDefault();
        event.stopPropagation();
        
        // Find and click the zoom button (the plus icon)
        var zoomButton = document.querySelector('[data-action="open-product-zoom"]');
        if (zoomButton) {
          zoomButton.click();
        }
      }
    }, true); // Use capture phase to ensure it fires before other handlers
  }
});


// Defensive: ensure scrolling is not accidentally locked on mobile
document.addEventListener('DOMContentLoaded', function() {
  function anyOverlayOpen() {
    // Common open states for modals/drawers/search in this theme
    return Boolean(
      document.querySelector('.Modal[aria-hidden="false"], .Drawer[aria-hidden="false"], .Search[aria-hidden="false"], .PageOverlay.is-visible')
    );
  }

  function ensureScrollUnlocked() {
    if (!anyOverlayOpen() && document.documentElement.classList.contains('no-scroll')) {
      document.documentElement.classList.remove('no-scroll');
      try { if (typeof disableBodyScroll === 'function') { disableBodyScroll(false, "[data-scrollable]"); } } catch (e) {}
      document.body.style.overflow = '';
    }
  }

  // Run on interactions that indicate the page should be scrollable
  window.addEventListener('scroll', ensureScrollUnlocked, { passive: true });
  document.addEventListener('touchstart', ensureScrollUnlocked, { passive: true });
  document.addEventListener('click', ensureScrollUnlocked, true);
  document.addEventListener('keydown', ensureScrollUnlocked);

  // Also run shortly after load
  setTimeout(ensureScrollUnlocked, 300);
});

/**CLP - Filter section transition js */
const toolbarLayout = document.querySelector('.custom-toolbar-layout');
let lastScroll = window.pageYOffset;
let ticking = false;

window.addEventListener('scroll', function() {
  if (!ticking) {
    window.requestAnimationFrame(function() {
      const currentScroll = window.pageYOffset;
      if (currentScroll > lastScroll && currentScroll > 100) {
        // Scrolling down, hide the toolbar
        toolbarLayout.style.transform = 'translateY(-100%)';
        toolbarLayout.style.transition = 'transform 0.3s ease';
      } else if (currentScroll < lastScroll) {
        // Scrolling up, show the toolbar
        toolbarLayout.style.transform = 'translateY(0)';
      }
      lastScroll = currentScroll <= 0 ? 0 : currentScroll; // Prevent negative scroll
      ticking = false;
    });
    ticking = true;
  }
});

document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        body.classList.add('is-tabbing');
      }
    });
    window.addEventListener('mousedown', () => {
      body.classList.remove('is-tabbing');
    });
  });


